import { useState } from "react";
import Grid from "@mui/material/Grid";
import { usePut } from "../../actprep-ui/hooks/api";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";
import { apiUrls } from "../../actprep-ui/utils/urls";
import CreationFormWrapper from "../../actprep-ui/components/CreationFormWrapper";
import ModelAutoComplete from "../../actprep-ui/components/ModelAutoComplete";
import ProgramWeekForm from "../ProgramWeekForm";

export default function SwitchProgramWeekForm({
  open,
  setOpen,
  program,
  order,
  currentProgramWeek,
  onProgramWeekSwitched,
}) {
  const [error, setError] = useState(null);
  const [programWeek, setProgramWeek] = useState(null);
  const addProgramWeekToProgramMutation = usePut(
    apiUrls.admin.programWeekToProgram()
  );
  const onSubmit = async (event) => {
    event.preventDefault();
    if (programWeek.uuid === currentProgramWeek.uuid) {
      setOpen(false);
      return;
    }

    const payload = {
      order: order,
      program_uuid: program?.uuid,
      new_program_week_uuid: programWeek.uuid,
    };
    const { data } = await addProgramWeekToProgramMutation.mutateAsync(payload);
    if (!data.success) {
      setError(data.reason);
      return;
    }
    setOpen(false);
    onProgramWeekSwitched();
    showSuccessSnackbar("Program Week Switched!");
  };
  const handleClose = () => setOpen(false);

  return (
    <CreationFormWrapper
      open={open}
      onClose={handleClose}
      onSubmit={onSubmit}
      error={error}
      title={`Switch Week ${order + 1} on '${program?.title}' Program`}
      confirmText="Switch"
    >
      <Grid container gap={3} marginTop={1}>
        <Grid size={12}>
          <ModelAutoComplete
            modelName={"ProgramWeek"}
            label={"New Program Week"}
            value={programWeek}
            setValue={setProgramWeek}
            allowCreation
            CreationForm={(props) => <ProgramWeekForm {...props} />}
          />
        </Grid>
      </Grid>
    </CreationFormWrapper>
  );
}
